import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgRemove = (props: SvgIconProps) =>
  React.createElement(SvgIcon, props, <path d="M7 13a1 1 0 1 1 0-2h10a1 1 0 1 1 0 2H7Z" />)
export default SvgRemove
